import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modal';
import { editProfileData, sendOTPMobile, updateEmail } from '../../actions/personalInfo';
import { getFieldsFromDateAsFormat } from '../../../utils/dateFormatter';
import { login } from '../../../userauth/actions/signinAction';
import { validateEmail, validatePassword } from '../../../utils/inputValidator';
import Loader from '../../../components/common/Loader';

const MESSAGES = {
  ERREMAIL: 'Please enter a new email ID.',
  ERRPASS: 'Please enter the existing password.',
  VALIDEMAIL: 'Please enter a valid email address.',
  VALIDPASS:
    'Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.'
};

class UpdateEmailIdKioskPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newEmail: '',
      userPwd: '',
      errEmail: '',
      errPwd: '',
      disableCTA: true
    };
  }

  handleLogin = (updateEmail, custProfile) => {
    const { newEmail = '', userPwd = '' } = this.state;
    updateEmail(custProfile, () => {
      if (this.props.statusCode === 201) {
        var signInObj = {};
        signInObj = {
          username: newEmail.toLowerCase(),
          password: userPwd
          // "device":  this.props.viewSiteAs || window.device
        };
        this.props.login(signInObj, () => {
          // change emailAddress to username
          if (this.props.validUser) {
            this.setState({
              errEmail: '',
              errPwd: ''
            });

            this.props.hideModal('update-email');
            window.location.reload();
          }
        });
      } else if (this.props.statusCode === 400 || this.props.statusCode === 401) {
        if (this.props.type === 'Email Update Error') {
          this.setState({
            errEmail: this.props.message,
            errPwd: ''
          });
        } else {
          this.setState({
            errPwd: this.props.message,
            errEmail: ''
          });
        }
      }
    });
  };

  handleChange(field, value) {
    const { disableCTA, newEmail, userPwd } = this.state;
    let cta = disableCTA;
    if (field === 'newEmail') {
      if (value !== '' && userPwd !== '') cta = false;
      else cta = true;
    }
    if (field === 'userPwd') {
      if (value !== '' && newEmail !== '') cta = false;
      else cta = true;
    }
    this.setState({
      [field]: value,
      disableCTA: cta
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    const { newEmail = '', userPwd = '' } = this.state;
    ga('send', {
      eventCategory: 'buttonTap',
      eventAction: 'Change Personal Info',
      eventLabel: 'Save New Email Address'
    });
    if (newEmail && userPwd && validateEmail(newEmail) && validatePassword(userPwd)) {
      let custProfile = {
        emailAddress: newEmail.toLowerCase(),
        password: userPwd,
        screenName: this.props.screenName
      };
      this.setState({
        errEmail: '',
        errPwd: ''
      });
      this.handleLogin(this.props.updateEmail, custProfile);
    } else if (!newEmail && !userPwd) {
      this.setState({
        errEmail: MESSAGES.ERREMAIL,
        errPwd: MESSAGES.ERRPASS
      });
    } else if (!newEmail) {
      this.setState({
        errEmail: MESSAGES.ERREMAIL,
        errPwd: ''
      });
    } else if (!userPwd) {
      this.setState({
        errEmail: '',
        errPwd: MESSAGES.ERRPASS
      });
      if (!validateEmail(newEmail)) {
        this.setState({
          errEmail: MESSAGES.VALIDEMAIL
        });
      }
    } else if (!validateEmail(newEmail)) {
      this.setState({
        errEmail: MESSAGES.VALIDEMAIL,
        errPwd: ''
      });
    } else if (!validatePassword(userPwd)) {
      this.setState({
        errEmail: '',
        errPwd: MESSAGES.VALIDPASS
      });
    }
  };

  render() {
    return (
      <form
        className="update-mobile-form"
        id="updateEmailForm"
        noValidate
        onSubmit={this.handleSubmit}
      >
        <Loader name="mobile-num-popup" />
        <p className="update-mobile-no-text"> Enter New Email Address </p>
        <div className="update-mob-input-field-block">
          <div className="email-id">
            <input
              className="update-mobile-mod-input"
              name="newEmail"
              size="32"
              maxLength="254"
              type="email"
              autoComplete="email"
              value={this.state.newEmail}
              onChange={e => {
                this.handleChange('newEmail', e.target.value);
              }}
            />
            <label htmlFor="newEmail" className="newEmailLabel">
              Email Address
            </label>
            {this.state.errEmail && <div className="err-msg-email">{this.state.errEmail}</div>}
          </div>
          <div className="email-password">
            <input
              className="update-mobile-mod-input password-email"
              name="oldPwd"
              size="32"
              maxLength="254"
              type="password"
              value={this.state.userPwd}
              autoComplete="off"
              onChange={e => {
                this.handleChange('userPwd', e.target.value);
              }}
            />
            <label htmlFor="oldPwd" className="oldPwdLabel">
              Enter AJIO Password
            </label>
            {this.state.errPwd && <div className="err-msg-email">{this.state.errPwd}</div>}
          </div>
          <div className="password-msg-label">
            <span className="note">Note: </span>Use current password / enter a new password
          </div>
          <div className="mobaddaddr-type">
            <input
              type="submit"
              disabled={this.state.disableCTA}
              placeholder="save"
              className="update-mobile-mod-verify update-email-popup"
              value="SAVE NEW EMAIL ADDRESS"
            />
          </div>
        </div>
      </form>
    );
  }
}
const mapStatetoProps = state => {
  const { personalInfo = {}, signInReducer = {} } = state;
  const { validUser = false } = signInReducer;
  const { emailUpdate = {}, profile: { screenName = '', uid = '' } = {} } = personalInfo;
  const { statusCode = '', message = '', type = '' } = emailUpdate;
  return {
    statusCode,
    message,
    type,
    validUser,
    screenName,
    uid
  };
};
const mapDispatchToProps = dispatch => {
  return {
    editProfileData: formData => {
      dispatch(editProfileData(formData));
    },
    updateEmail: (formData, callback) => {
      dispatch(updateEmail(formData, callback));
    },
    login: (formData, callback) => {
      dispatch(login(formData, callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
export default UpdateEmailIdKioskPopup = connect(
  mapStatetoProps,
  mapDispatchToProps
)(UpdateEmailIdKioskPopup);
